import { render, staticRenderFns } from "./FeatureTags.vue?vue&type=template&id=52d4515f&scoped=true"
import script from "./FeatureTags.vue?vue&type=script&lang=js"
export * from "./FeatureTags.vue?vue&type=script&lang=js"
import style0 from "./FeatureTags.vue?vue&type=style&index=0&id=52d4515f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d4515f",
  null
  
)

export default component.exports